export default "__VITE_ASSET__D4i3mNAB__"